import PropTypes from "prop-types";
import React,  { useState, useEffect, useCallback } from "react";
import withRouter from "components/Common/withRouter";
import {
  changeLayout,
  changeLayoutMode,
  changeSidebarTheme,
  changeSidebarThemeImage,
  changeSidebarType,
  changeTopbarTheme,
  changeLayoutWidth,
  showRightSidebarAction
} from "../../store/actions";
import { SIDEBAR_MOBILE_MEDIA_QUERY } from "../../constants/layout";

// Layout Related Components
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import RightSidebar from "../CommonForBoth/RightSidebar";

//redux
import { useSelector, useDispatch } from "react-redux";
import AuthService from "../../services/Auth.service";

const Layout = props => {
  const dispatch = useDispatch();

  const {
    isPreloader,
    leftSideBarThemeImage,
    layoutWidth,
    leftSideBarType,
    topbarTheme,
    showRightSidebar,
    leftSideBarTheme,
    layoutModeType
  } = useSelector(state => ({
    isPreloader: state.Layout.isPreloader,
    layoutModeType: state.Layout.layoutModeType,
    leftSideBarThemeImage: state.Layout.leftSideBarThemeImage,
    leftSideBarType: state.Layout.leftSideBarType,
    layoutWidth: state.Layout.layoutWidth,
    topbarTheme: state.Layout.topbarTheme,
    showRightSidebar: state.Layout.showRightSidebar,
    leftSideBarTheme: state.Layout.leftSideBarTheme,
  }));

  // Gaveta do mobile: estado LOCAL de UI, efêmero e restrito a este subtree —
  // não vai ao Redux de propósito. `sidebar-enable` é inerte no desktop (só é
  // lido dentro do @media do mobile), então não precisa checar viewport aqui.
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Mantém EMPRESAS do síndico sincronizadas sem precisar de novo login
  useEffect(() => {
    const session = AuthService.getCurrentUser();
    const status = Number(session?.user?.DS_STATUS);
    if (status !== 1) return undefined;

    AuthService.refreshEmpresas();

    const onFocus = () => {
      AuthService.refreshEmpresas();
    };
    window.addEventListener("focus", onFocus);
    return () => window.removeEventListener("focus", onFocus);
  }, []);

  const toggleMobileMenu = useCallback(
    () => setMobileMenuOpen(open => !open),
    []
  );
  const closeMobileMenu = useCallback(() => setMobileMenuOpen(false), []);

  useEffect(() => {
    document.body.classList.toggle("sidebar-enable", mobileMenuOpen);
    return () => document.body.classList.remove("sidebar-enable");
  }, [mobileMenuOpen]);

  //hides right sidebar on body click
  const hideRightbar = (event) => {
    var rightbar = document.getElementById("right-bar");
    //if clicked in inside right bar, then do nothing
    if (rightbar && rightbar.contains(event.target)) {
      return;
    } else {
      //if clicked in outside of rightbar then fire action for hide rightbar
      dispatch(showRightSidebarAction(false));
    }
  };

  /*
  layout  settings
  */

  useEffect(() => {
    //init body click event fot toggle rightbar
    document.body.addEventListener("click", hideRightbar, true);


  }, []);

  const [hasAcceptedTerms, setHasAcceptedTerms] = useState(false)

  useEffect(() => {
    const accepted = localStorage.getItem("termsAccepted");
    // setHasAcceptedTerms(!!accepted);
    setHasAcceptedTerms(true);
  }, []);


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    dispatch(changeLayout("vertical"));
  }, [dispatch]);

  useEffect(() => {
    if (leftSideBarTheme) {
      dispatch(changeSidebarTheme(leftSideBarTheme));
    }
  }, [leftSideBarTheme, dispatch]);

  useEffect(() => {
    if (layoutModeType) {
      dispatch(changeLayoutMode(layoutModeType));
    }
  }, [layoutModeType, dispatch]);

  useEffect(() => {
    if (leftSideBarThemeImage) {
      dispatch(changeSidebarThemeImage(leftSideBarThemeImage));
    }
  }, [leftSideBarThemeImage, dispatch]);

  useEffect(() => {
    if (layoutWidth) {
      dispatch(changeLayoutWidth(layoutWidth));
    }
  }, [layoutWidth, dispatch]);

  useEffect(() => {
    if (leftSideBarType) {
      dispatch(changeSidebarType(leftSideBarType));
    }
  }, [leftSideBarType, dispatch]);

  // Ao cruzar o breakpoint: fecha a gaveta e reaplica o tipo do menu. Indo pro
  // mobile, a saga remove `vertical-collpsed` (senão ele ficaria grudado e o
  // próximo toque no hambúrguer mostraria o rail); voltando pro desktop, ela
  // restaura o rail se era a preferência salva do usuário.
  useEffect(() => {
    const mql = window.matchMedia(SIDEBAR_MOBILE_MEDIA_QUERY);
    const handleChange = () => {
      setMobileMenuOpen(false);
      dispatch(changeSidebarType(leftSideBarType));
    };
    mql.addEventListener("change", handleChange);
    return () => mql.removeEventListener("change", handleChange);
  }, [dispatch, leftSideBarType]);

  useEffect(() => {
    if (topbarTheme) {
      dispatch(changeTopbarTheme(topbarTheme));
    }
  }, [topbarTheme, dispatch]);

  return (
    <React.Fragment>
      {/* <div id="preloader">
        <div id="status">
          <div className="spinner-chase">
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
          </div>
        </div>
      </div> */}

      <div id="layout-wrapper">
        <Header onToggleMobileMenu={toggleMobileMenu} />
        {hasAcceptedTerms ? (
          <>
            <Sidebar
              theme={leftSideBarTheme}
              type={leftSideBarType}
              onCloseMobileMenu={closeMobileMenu}
            />
            {/* Renderizado sempre; quem decide se aparece é o CSS
                (.sidebar-overlay só vira display:block no @media do mobile). */}
            <div
              className="sidebar-overlay"
              onClick={closeMobileMenu}
              aria-hidden="true"
            />
          </>

          ) : (
                <>

                </>
            )}

        {hasAcceptedTerms ? (
          <>
           <div className="main-content">{props.children}</div>
          </>
           ) : (
            <>
            <div className="main-contentt">{props.children}</div>
            </>
        )}
        
        <Footer />
      </div>
      {showRightSidebar ? <RightSidebar /> : null}
    </React.Fragment>
  );
};

Layout.propTypes = {
  changeLayoutWidth: PropTypes.func,
  changeSidebarTheme: PropTypes.func,
  changeSidebarThemeImage: PropTypes.func,
  changeSidebarType: PropTypes.func,
  changeTopbarTheme: PropTypes.func,
  children: PropTypes.any,
  isPreloader: PropTypes.any,
  layoutWidth: PropTypes.any,
  leftSideBarTheme: PropTypes.any,
  leftSideBarThemeImage: PropTypes.any,
  leftSideBarType: PropTypes.any,
  location: PropTypes.object,
  showRightSidebar: PropTypes.any,
  topbarTheme: PropTypes.any,
};

export default withRouter(Layout);
